import Swal from 'sweetalert2'
import {
    IS_LOADING_ACTION_AWARDS,
    IS_ERROR_ACTION_AWARDS,
    CREATE_ACTION_AWARD,
    UPDATE_ACTION_AWARD,
    GET_ACTION_AWARD_INFO,
    ACTION_AWARD_LIST,
    DELETE_ACTION_AWARD_INFO,
    IS_LOADING_CHALLENGE_AWARDS,
    CREATE_CHALLENGE_AWARD,
    UPDATE_CHALLENGE_AWARD,
    DELETE_CHALLENGE_AWARD,
    CHALLENGE_AWARD_LIST,
    GET_CHALLENGE_AWARD_INFO,
    IS_LOADING_TYPES_OF_AWARDS,
    CREATE_TYPE_OF_AWARD,
    UPDATE_TYPE_OF_AWARDS,
    DELETE_TYPE_OF_AWARD,
    TYPES_OF_AWARDS_LIST,
    GET_TYPE_OF_AWARD_INFO,
    IS_LOADING_AWARDS,
    CREATE_AWARD,
    UPDATE_AWARDS,
    DELETE_AWARD,
    AWARDS_LIST,
    GET_AWARD_INFO,
    IS_LOADING_RANKS,
    CREATE_RANK, GET_RANK_INFO,
    UPDATE_RANK, DELETE_RANK, RANKS_LIST, GET_RANK_AVANCE
} from './types'
import {
    urlServer
} from '../../config/GlobalConstant'
import inMemoryJWT from '../../auth/inMemoryJwt';

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000
})


///activities for challenges awards admin 
export const createActionAward = (actionAward, history,cleaner) => async dispatch => {
    dispatch({
        type: IS_LOADING_ACTION_AWARDS
    });
    await fetch(`${urlServer}adminsystemactions/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(actionAward)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
           if(respJson.success){
            dispatch({
                type: CREATE_ACTION_AWARD,
                payload: actionAward
            });
            cleaner()
           }else{
            dispatch({
                type: IS_ERROR_ACTION_AWARDS
            });
            if(respJson.error.code =="ERR032"){
                Toast.fire({
                    icon:"error",
                    text:"Ya existe la acción"
                })
            }else{
                Toast.fire({
                    icon:"error",
                    text:"No se pudo crear la acción"
                })
            }
               
           }
           
        })
        .catch(error => {
            console.log()
        })
}

export const editActionAward = (body, index, history,clean) => async dispatch => {
    dispatch({
        type: IS_LOADING_ACTION_AWARDS
    });
    await fetch(`${urlServer}adminsystemactions/update`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(body)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            var actionAward = respJson.data
            if(respJson.success){
                clean()
                dispatch({
                    type: UPDATE_ACTION_AWARD,
                    payload: {
                        actionAward,
                        index
                    }
                });
            }else{
                dispatch({
                    type: IS_ERROR_ACTION_AWARDS
                });
                if(respJson.error.code=="MSJ015"){
                    Toast.fire({
                        icon:"error",
                        text:"Ya hay una acción"
                    })
                }else{
                    Toast.fire({
                        icon:"error",
                        text:"No se pudo actualizar la acción"
                    })
                }
              
            }
           
            
        })
        .catch(error => {
            console.log()
        })
}

export const deleteActionAward = (id, index, history) => async dispatch => {
    dispatch({
        type: IS_LOADING_ACTION_AWARDS
    });
    await fetch(`${urlServer}adminsystemactions/delete`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            actionID: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success) {
                dispatch({
                    type: DELETE_ACTION_AWARD_INFO,
                    payload: index
                });
            }else{
                dispatch({
                    type: IS_ERROR_ACTION_AWARDS
                });
                Toast.fire({
                    icon: 'error',
                    title: 'No se puede eliminar este registro'
                })
            }

        })
        .catch(error => {
            console.log()
        })
}

export const seeListActionAward = (history) => async dispatch => {
    await fetch(`${urlServer}adminsystemactions/get-all`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_ACTION_AWARDS
            });
            dispatch({
                type: ACTION_AWARD_LIST,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}
export const getAdvance = (id) => async dispatch => {
    await fetch(`${urlServer}entitylevels/get-advance`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            userId: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if(respJson.success){
                dispatch({
                    type: GET_RANK_AVANCE,
                    payload: respJson.data
                });
            }

           
        })
        .catch(error => {
            console.log()
        })
}

export const getActionAward = (id, history) => async dispatch => {
    await fetch(`${urlServer}api/systemaction/id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            id: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_ACTION_AWARDS
            });
            dispatch({
                type: GET_ACTION_AWARD_INFO,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}


///challenges awards admin 
export const createChallengeAward = (challengeAward, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/challenge/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(challengeAward)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_CHALLENGE_AWARDS
            });
            dispatch({
                type: CREATE_CHALLENGE_AWARD,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const editChallengeAward = (challengeAward, index, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/challenge/update-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(challengeAward)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_CHALLENGE_AWARDS
            });
            dispatch({
                type: UPDATE_CHALLENGE_AWARD,
                payload: {
                    challengeAward: respJson.data,
                    index: index
                }
            });
        })
        .catch(error => {
            console.log()
        })
}

export const deleteChallengeAward = (id, index, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/challenge/delete-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            id: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_CHALLENGE_AWARDS
                });
                dispatch({
                    type: DELETE_CHALLENGE_AWARD,
                    payload: index
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const seeListChallengeAward = (history) => async dispatch => {
    await fetch(`${urlServer}api/challenge/enabled/`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_CHALLENGE_AWARDS
            });
            dispatch({
                type: CHALLENGE_AWARD_LIST,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const getChallengeAward = (id, history) => async dispatch => {
    await fetch(`${urlServer}api/challenge/id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            id: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_CHALLENGE_AWARDS
            });
            dispatch({
                type: GET_CHALLENGE_AWARD_INFO,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

///types of awards admin 
export const createTypeOfAward = (typeOfAward, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/typeofaward/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(typeOfAward)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_TYPES_OF_AWARDS
            });
            dispatch({
                type: CREATE_TYPE_OF_AWARD,
                payload: typeOfAward
            });
        })
        .catch(error => {
            console.log()
        })
}

export const editTypeOfAward = (typeOfAward, index, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/typeofaward/update-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(typeOfAward)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_TYPES_OF_AWARDS
            });
            dispatch({
                type: UPDATE_TYPE_OF_AWARDS,
                payload: {
                    typeOfAward: respJson.data,
                    index
                }
            });
        })
        .catch(error => {
            console.log()
        })
}

export const deleteTypeOfAward = (id, index, history) => async dispatch => {
    await fetch(`${urlServer}api/typeofaward/delete-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            id: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_TYPES_OF_AWARDS
            });
            dispatch({
                type: DELETE_TYPE_OF_AWARD,
                payload: index
            });
        })
        .catch(error => {
            console.log()
        })
}

export const seeListTypeOfAward = (history) => async dispatch => {
    await fetch(`${urlServer}api/typeofaward`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_TYPES_OF_AWARDS
            });
            dispatch({
                type: TYPES_OF_AWARDS_LIST,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const getTypeOfAward = (id, history) => async dispatch => {
    await fetch(`${urlServer}api/typeofaward/id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            id: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_TYPES_OF_AWARDS
            });
            dispatch({
                type: GET_TYPE_OF_AWARD_INFO,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

//awards Admin

export const createAward = (award, history) => async dispatch => {
    for (var pair of award.entries()) {
        console.log();
    }
    await fetch(`${urlServer}api/award/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            //'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
        }, // body data type must match "Content-Type" header    
        body: award
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_AWARDS
                });
                dispatch({
                    type: CREATE_AWARD,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const editAward = (awardUpdated, index, history) => async dispatch => {
    for (var pair of awardUpdated.entries()) {
        console.log();
    }
    console.log()
    await fetch(`${urlServer}api/award/update-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            //'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
        }, // body data type must match "Content-Type" header    
        body: awardUpdated
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                var awardEdited = respJson.data
                dispatch({
                    type: IS_LOADING_AWARDS
                });
                dispatch({
                    type: UPDATE_AWARDS,
                    payload: {
                        awardEdited,
                        index
                    }
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const deleteAward = (id, index, history) => async dispatch => {
    await fetch(`${urlServer}api/award/delete-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            id: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_AWARDS
                });
                dispatch({
                    type: DELETE_AWARD,
                    payload: index
                });
            }
            else {
                Toast.fire({
                    icon: 'error',
                    title: 'No se puede eliminar este registro'
                })
            }
        })
        .catch(error => {
            console.log()
        })
}

export const seeListAward = (history) => async dispatch => {
    await fetch(`${urlServer}api/award/`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_AWARDS
                });
                dispatch({
                    type: AWARDS_LIST,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getAward = (id, history) => async dispatch => {
    await fetch(`${urlServer}api/award/id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            id: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_AWARDS
            });
            dispatch({
                type: GET_AWARD_INFO,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

///rank management
export const createRank = (rank) => async dispatch => {
 
    await fetch(`${urlServer}adminlevels/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            //'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
        }, // body data type must match "Content-Type" header    
        body: rank
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_RANKS
                });
                dispatch({
                    type: CREATE_RANK,
                    payload: respJson.data
                });
            }
            if (respJson.success === false && respJson.error.code === "ERR005") {
                Toast.fire({
                    icon: 'error',
                    title: 'El registro ya existe'
                })
            }
            if (respJson.success === false && respJson.error.code === "ERR099") {
                Toast.fire({
                    icon: 'error',
                    title: 'El puntaje requerido debe ser mayor a los existentes'
                })
            }
        })
        .catch(error => {
            console.log()
        })
}



export const editRank = (rank, index, history) => async dispatch => {
    
    console.log()
    await fetch(`${urlServer}adminlevels/update`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            //'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
        }, // body data type must match "Content-Type" header    
        body: rank
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()

            if (respJson.error && respJson.error.code === "ERR100") {
                Toast.fire({
                    icon: 'error',
                    title: 'El puntaje requerido debe estar dentro de un rango permitido (no puede ser menor a un rango anterior ni mayor a uno superior)'
                })
            }
            if (respJson.success === true) {
                var rankEdited = respJson.data
                dispatch({
                    type: IS_LOADING_RANKS
                });
                dispatch({
                    type: UPDATE_RANK,
                    payload: {
                        rankEdited,
                        id:respJson.data._id
                    }
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const deleteRank = (id, index, history) => async dispatch => {
    await fetch(`${urlServer}api/rank/delete-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            id: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_RANKS
                });
                dispatch({
                    type: DELETE_RANK,
                    payload: index
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const seeListRanks = (history) => async dispatch => {
    await fetch(`${urlServer}adminlevels/get-all`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_RANKS
                });
                dispatch({
                    type: RANKS_LIST,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getRank = (id, history) => async dispatch => {
    await fetch(`${urlServer}api/rank/id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            id: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_RANKS
                });
                dispatch({
                    type: GET_RANK_INFO,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}